import React from 'react';

import Button from 'shared/button';
import Modal from 'components/modal';

interface Props {
  saving?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function confirmPropertyMerge({ saving, onClose, onConfirm }: Props) {
  return <>
    <Modal.Body className="d-flex flex-column gap-3">
      <div> You are about to merge two properties. </div>
      <div> This action is permanent and cannot be undone. Are you sure you want to merge? </div>
    </Modal.Body>
    <Modal.Footer>
      <Button.Cancel onClick={onClose} />
      <Button.Primary disabled={saving} label="Merge Properties" onClick={onConfirm} />
    </Modal.Footer>
    </>;
}
